
<div *ngIf="form" [formGroup]="form">
  <kodit-card-container>
    <div card-body class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
      <kodit-field
        fieldLabel="Generiši broj po pravilu"
        fieldLabelFor="pravilo-za-broj"
        class="flex-1"
      >
        <kodit-pravilo-za-broj-racuna-dropdown
          [formCtrl]="form.controls.praviloZaBrojId"
          formCtrlId="pravilo-za-broj"
          [tipRacuna]="tipRacuna"
        >
        </kodit-pravilo-za-broj-racuna-dropdown>
      </kodit-field>

      <div class="p-field flex-1">
        <label for="tip-otpremnice" kodit-form-label>Tip otpremnice:</label>
        <kodit-tip-otpremnice-dropdown
          [formCtrl]="form.controls.tipOtpremnice!"
          (onItemChange)="onTipChange($event)"
        >
        </kodit-tip-otpremnice-dropdown>
      </div>
      <div class="p-field flex-1 p-mt-5">
        <kodit-checkbox
          labelText="Povrat robe"
          [formCtrl]="form.controls.povratRobe!"
        ></kodit-checkbox>
      </div>
    </div>

    <div
      card-body
      class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid mt-2"
    >
      <div class="p-field flex-1">
        <label for="broj-paketa" kodit-form-label>Broj paketa</label>
        <kodit-number-input
          formCtrlId="broj-paketa"
          [formCtrl]="form.controls.brojPaketa"
          [ctrlOnlyIntegers]="true"
        >
        </kodit-number-input>
      </div>

      <div class="p-field flex-5">
        <label for="rok" kodit-form-label>Težina isporuke(bruto)</label>
        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <div class="p-field flex-1">
            <kodit-number-input
              formCtrlId="tezina-isporuke"
              [formCtrl]="form.controls.tezinaIsporuke"
            >
            </kodit-number-input>
          </div>
          <div class="p-field flex-2">
            <kodit-jedinica-mere-dropdown
              [jedinicaMereGroup]="form.controls.jedinicaMereTezinaDto"
              formCtrlId="jedinicaMereTezinaDto"
              (onChange)="changeJedinicaTezina($event.value)"
              [jeTezinaIsooruke]="true"
            >
            </kodit-jedinica-mere-dropdown>
          </div>
        </div>
      </div>
      <div class="p-field flex-3">
        <label for="rok" kodit-form-label>Zapremina isporuke(bruto)</label>
        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <div class="p-field flex-1">
            <kodit-number-input
              formCtrlId="zapremina-isporuke"
              [formCtrl]="form.controls.zapreminaIsporuke"
            >
            </kodit-number-input>
          </div>
          <div class="p-field flex-2">
            <kodit-jedinica-mere-dropdown
              [jedinicaMereGroup]="form.controls.jedinicaMereZapreminaDto"
              formCtrlId="jedinicaMereZapreminaDto"
              (onChange)="changeJedinicaZapremina($event.value)"
              [jeZapreminaIsporuke]="true"
            >
            </kodit-jedinica-mere-dropdown>
          </div>
        </div>
      </div>
    </div>
  </kodit-card-container>

  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid p-mt-5">
    <div class="flex-50">
      <kodit-card-container>
        <div card-title>Datumi otpreme</div>
        <div card-body>
          <kodit-field
            fieldLabelFor="planirani-datum-pocetka"
            fieldLabel="Planirani datum i vreme početka otpreme"
            class="flex-1"
          >
            <kodit-calendar
              class="p-ml-3"
              formCtrlId="planirani-datum-pocetka"
              [formCtrl]="form.controls.planiraniDatumPocetka!"
              [showTime]="true"
            ></kodit-calendar>
          </kodit-field>
          <kodit-field
            fieldLabelFor="planirani-datum-pocetka"
            fieldLabel="Planirani datum i vreme završetka otpreme"
            class="flex-1"
          >
            <kodit-calendar
              class="p-ml-3"
              formCtrlId="planirani-datum-zavrsetka"
              [formCtrl]="form.controls.planiraniDatumZavrsetka!"
               [showTime]="true"
            ></kodit-calendar>
          </kodit-field>
          <kodit-field
            fieldLabelFor="planirani-datum-zavrsetka"
            fieldLabel="Stvarni datum i vreme otpreme"
            class="flex-1"
          >
            <kodit-calendar
              class="p-ml-3"
              formCtrlId="stvarni-datum-otprme"
              [formCtrl]="form.controls.stvarniDatum!"
              [showTime]="true"
            ></kodit-calendar>
          </kodit-field>
        </div>
      </kodit-card-container>
    </div>

    <div class="flex-50 p-ml-3">
      <kodit-card-container>
        <div card-title>Primalac</div>
        <div card-body>
          <kodit-field fieldLabelFor="primalac-stranka">
            <kodit-stranka-eotpremnice
              [otpremnicaFormGroup]="form"
            ></kodit-stranka-eotpremnice>
          </kodit-field>
        </div>
      </kodit-card-container>
    </div>
  </div>
  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Podaci kontakt osoba</div>
      <div
        card-body
        class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid p-mt-5"
      >
        <!-- Posiljalac kontakt -->
        <div class="flex-50 p-d-flex p-flex-column gap-12">
          <h5>Pošiljalac kontakt</h5>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-ime"
              formCtrlLabel="Ime"
              [formCtrl]="form.controls.posiljalacKontaktDto?.get('ime')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-telefon"
              formCtrlLabel="Telefon"
              [formCtrl]="form.controls.posiljalacKontaktDto?.get('telefon')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex mt-2">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-email"
              formCtrlLabel="Email"
              [formCtrl]="form.controls.posiljalacKontaktDto?.get('email')"
              class="flex-1"
            >
            </kodit-text-input-field>
          </div>
        </div>

        <!-- Primalac kontakt -->
        <div class="flex-50 p-d-flex p-flex-column gap-12">
          <h5>Primalac kontakt</h5>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12">
            <kodit-text-input-field
              formCtrlId="primalac-kontakt-ime"
              formCtrlLabel="Ime"
              [formCtrl]="form.controls.primalacKontaktDto?.get('ime')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="primalac-kontakt-telefon"
              formCtrlLabel="Telefon"
              [formCtrl]="form.controls.primalacKontaktDto?.get('telefon')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex mt-2">
            <kodit-text-input-field
              formCtrlId="primalac-kontakt-email"
              formCtrlLabel="Email"
              [formCtrl]="form.controls.primalacKontaktDto?.get('email')"
              class="flex-1"
            >
            </kodit-text-input-field>
          </div>
        </div>
      </div>
    </kodit-card-container>
  </div>

  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Podaci otpreme</div>
      <kodit-button
          *ngIf="jePretovar"
          btnLabel="Sačuvaj pretovar"
          btnIcon="fas fa-circle-check"
          btnClass="p-button-success p-mt-3"
          (btnClicked)="evidentirajPretovar()"
          card-right-side
      ></kodit-button>
      <div class="p-field" card-body #scrollTarget>
        <label for="tip-otpremnice" kodit-form-label>Način otpreme:</label>
        <kodit-nacin-otpreme-dropdown
          [formCtrl]="form.controls.nacinOtpreme!"
          (onItemChange)="onNacinOtpremeChange($event)"
        >
        </kodit-nacin-otpreme-dropdown>
      </div>
      <div card-body>
        <kodit-faze-voznje [otpremnicaFormGroup]="form"> </kodit-faze-voznje>
      </div>
    </kodit-card-container>
  </div>

  <div class="p-mt-5">
    <kodit-card-container>
      <div card-title>Adrese isporuke</div>
      <div
        card-body
        class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid p-mt-5"
      >
        <!-- Adresa otpreme -->
        <div class="flex-50 p-d-flex p-flex-column gap-12">
          <h5>Adresa otpreme</h5>
          <div
            #magacinOtpremeWrapper
            class="p-d-flex p-flex-column gap-12"
            [class.magacin-required-highlight]="magacinRequiredHighlight"
          >
            <label kodit-form-label>Magacin *</label>
            <kodit-adresa-magacin-autocomplete
              (onAdresaChange)="onSelectionAdresaOtpremeChange($event)"
              (onClear)="onSelectionAdresaOtpremeClear()"
              [ctrlPlaceholder]="form.controls.adresaOtpremeDto?.get('nazivMagacina').value ?? 'Unesite naziv magacina'"
              [jeAdresaOtpreme]="true"
              [isInvalid]="magacinRequiredHighlight"
           >
           </kodit-adresa-magacin-autocomplete>
          </div>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-ime"
              formCtrlLabel="Ulica"
              [formCtrl]="form.controls.adresaOtpremeDto?.get('ulica')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-telefon"
              formCtrlLabel="Broj"
              [formCtrl]="form.controls.adresaOtpremeDto?.get('broj')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12 mt-2">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-email"
              formCtrlLabel="Mesto"
              [formCtrl]="form.controls.adresaOtpremeDto?.get('mesto')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-telefon"
              formCtrlLabel="Poštanski broj"
              [formCtrl]="form.controls.adresaOtpremeDto?.get('postanskiBroj')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex mt-2">

            <kodit-text-input-field
              formCtrlId="sifra-objekta"
              formCtrlLabel="Šifra objekta"
              [formCtrl]="form.controls.adresaOtpremeDto?.get('sifraObjekta')"
              class="flex-1"
            >
            </kodit-text-input-field>
          </div>
        </div>

        <!-- Adresa odredista -->
        <div class="flex-50 p-d-flex p-flex-column gap-12">
          <h5>Adresa odredišta</h5>
          <label kodit-form-label>Magacin</label>
          <kodit-adresa-magacin-autocomplete
            (onAdresaChange)="onSelectionAdresaOdredistaChange($event)"
            (onClear)="onSelectionAdresaOdreditsaClear()"
            [ctrlDisabled]="!jeInterna"
            [jeAdresaOdredista]="true"
         >
         </kodit-adresa-magacin-autocomplete>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-ime"
              formCtrlLabel="Ulica"
              [formCtrl]="form.controls.adresaOdredistaDto?.get('ulica')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-telefon"
              formCtrlLabel="Broj"
              [formCtrl]="form.controls.adresaOdredistaDto?.get('broj')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12 mt-2">
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-email"
              formCtrlLabel="Mesto"
              [formCtrl]="form.controls.adresaOdredistaDto?.get('mesto')"
              class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
              formCtrlId="posiljalac-kontakt-telefon"
              formCtrlLabel="Poštanski broj"
              [formCtrl]="form.controls.adresaOdredistaDto?.get('postanskiBroj')"
              class="flex-50"
            >
            </kodit-text-input-field>
          </div>
          <div class="p-d-flex p-flex-column p-flex-md-row gap-12 mt-2">
            <kodit-text-input-field
              formCtrlId="sifra-objekta"
              formCtrlLabel="Šifra objekta"
              [formCtrl]="form.controls.adresaOdredistaDto?.get('sifraObjekta')"
              class="flex-1"
            >
            </kodit-text-input-field>
          </div>
        </div>
      </div>

      <div card-body class="p-mt-5">
        <kodit-field
          fieldLabelFor="napomena-isporuke"
          fieldLabel="Napomena isporuke"
        >
          <p-editor
            id="napomena-isporuke"
            [formControl]="form.controls.napomenaIsporuke"
            [style]="{ height: '150px' }"
          >
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <button
                  type="button"
                  class="ql-bold"
                  aria-label="Bold"
                ></button>
                <button
                  type="button"
                  class="ql-italic"
                  aria-label="Italic"
                ></button>
              </span>
            </ng-template>
          </p-editor>
          <kodit-error-info-max-length
            [formCtrl]="form.controls.napomenaIsporuke"
          ></kodit-error-info-max-length>
        </kodit-field>
      </div>
    </kodit-card-container>

    <div class="p-mt-5">
      <kodit-card-container>
        <div card-title>Stavke</div>
        <kodit-checkbox
          labelText="Omogući unos opasnih materija"
          [formCtrl]="form.controls.imaOpasneMaterije"
          card-right-side
        ></kodit-checkbox>
        <div card-body>
          <kodit-stavke-eotpremnice-table
            [otpremnicaForm]="form"
            (magacinRequired)="scrollToMagacinOtpreme()"
          ></kodit-stavke-eotpremnice-table>
        </div>
        <div card-body class="p-mt-5" *ngIf="form.controls.imaOpasneMaterije?.value">
            <kodit-card-container>
              <div card-title>Opasne materije</div>
              <div card-body>
                <kodit-opasne-materije-table
                  [otpremnicaForm]="form"
              ></kodit-opasne-materije-table>
              </div>
            </kodit-card-container>
        </div>
      </kodit-card-container>
    </div>

    <div class="p-mt-5">
      <kodit-card-container>
        <div card-title>Dodatne informacije</div>
        <div
          card-body
          class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid"
        >
          <kodit-text-input-field
            formCtrlId="broj-ugovora"
            formCtrlLabel="Broj ugovora"
            [formCtrl]="form.controls.brojUgovora"
            class="flex-50"
          >
          </kodit-text-input-field>
          <kodit-text-input-field
            formCtrlId="broj-narudzbenice"
            formCtrlLabel="Broj narudžbenice"
            [formCtrl]="form.controls.brojNarudzbenice"
            class="flex-50"
          >
          </kodit-text-input-field>
        </div>
        <div
          card-body
          class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid"
        >
<!--          <kodit-text-input-field-->
<!--            formCtrlId="roba-trece-strane"-->
<!--            formCtrlLabel="Roba treće strane"-->
<!--            [formCtrl]="form.controls.robaTreceStrane"-->
<!--            class="flex-50"-->
<!--          >-->
<!--          </kodit-text-input-field>-->
          <kodit-field fieldLabel="Roba treće strane" class="flex-50">
            <p-autoComplete
              [suggestions]="robaTreceStraneSuggestions"
              (completeMethod)="handleSearch($event)"
              (onSelect)="selectionChanged($event)"
              [placeholder]="ctrlPlaceholder"
              appendTo="body"
              field="brojOtpremniceTrecaStrana"
            >
              <ng-template let-item pTemplate="item">
                <div class="p-d-flex p-ai-center">
                  {{ item.brojOtpremniceTrecaStrana }}
                </div>
              </ng-template>
            </p-autoComplete>
          </kodit-field>
          <kodit-text-input-field
            formCtrlId="broj-okvirnog-sporazuma"
            formCtrlLabel="Broj okvirnog sporazuma"
            [formCtrl]="form.controls.brojOkvirnogSporazuma"
            class="flex-50"
          >
          </kodit-text-input-field>
        </div>
      </kodit-card-container>
    </div>

    <div class="p-mt-5">
      <kodit-card-container>
        <div card-title>Napomena</div>
        <div card-body>
          <kodit-field fieldLabelFor="napomena-isporuke">
            <p-editor
              id="napomena-isporuke"
              [formControl]="form.controls.napomena"
              [style]="{ height: '150px' }"
            >
              <ng-template pTemplate="header">
                <span class="ql-formats">
                  <button
                    type="button"
                    class="ql-bold"
                    aria-label="Bold"
                  ></button>
                  <button
                    type="button"
                    class="ql-italic"
                    aria-label="Italic"
                  ></button>
                </span>
              </ng-template>
            </p-editor>
            <kodit-error-info-max-length
              [formCtrl]="form.controls.napomena"
            ></kodit-error-info-max-length>
          </kodit-field>
        </div>
      </kodit-card-container>
    </div>
  </div>

  <div class="p-mt-5" card style="position: sticky; bottom: 0; z-index: 9">
    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-between">
      <div
        class="dodatne-akcije p-d-flex p-flex-column p-jc-around p-ml-3"
      ></div>
      <div class="primarne-akcije p-as-center p-d-flex gap-6">
        <ng-content></ng-content>
        <button
          pButton
          pRipple
          type="button"
          label="Zatvori"
          class="p-button-secondary p-button-outlined"
          pTooltip="Zatvori"
          tooltipPosition="bottom"
          (click)="handleRouteBack()"
          [disabled]="false"
        ></button>
        <button
          pButton
          pRipple
          icon="far fa-window-close"
          type="button"
          label="Otkaži"
          class="p-button-secondary p-button-outlined"
          pTooltip="Otkaži"
          tooltipPosition="bottom"
          (click)="handleCancel()"
          [disabled]="false"
        ></button>
        <button
          pButton
          icon="fas fa-save"
          type="submit"
          label="Sačuvaj"
          class="p-button-success"
          pTooltip="Sačuvaj"
          tooltipPosition="bottom"
          (click)="handleSave()"
          [disabled]="jePretovar"
          [loading]="false"
        ></button>
      </div>
    </div>
  </div>
</div>
